// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.

import type { FC } from 'react';

import { Icon, type IconProps } from './../../IconWrapper';

const SvgTiktokIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M15.55 2h-3.198v13.587c0 1.78-1.28 2.926-2.835 2.926-1.556 0-2.938-1.145-2.938-2.926 0-2.057 1.607-3.143 3.75-2.918V9.226a5.4 5.4 0 0 0-.881-.07C5.938 9.157 3 11.975 3 15.467 3 19.166 5.904 22 9.465 22c3.129 0 6.448-2.3 6.448-6.638v-7.07c1.383 1.383 3.06 1.815 4.857 1.815v-3.18C18.558 6.77 16.103 5.318 15.55 2" />
  </Icon>
);
export default SvgTiktokIcon;
SvgTiktokIcon.displayName = 'SvgTiktokIcon';
